// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"OC-z","smallCardRow":"PC-z","largeCardRow":"QC-z","productSearchRow":"RC-z","curatedRow":"SC-z"};